//Thumbnail image size constants
export const SQUARE = 'square';
export const WIDE = 'wide';
export const EXTRA_WIDE = 'x-wide';
